import { getStatic } from './const';
import { contextService } from '../../base/contextService';
import { getLangText } from '../../services/langService';
import { LANG_ENUM } from '@umu/umu-lang-switch';
/**
 * 用来表示满级的level数值
 */
export const FULL_USER_LEVEL = 999;

export const MEDAL_SIZE = {
    LARGE: 'L',
    SMALL: 'S',
};

/**
 * 用户等级， 判断是否满级
 * @param {int} level
 */
export function isFullUserLevel(level = 1) {
    return level === FULL_USER_LEVEL;
}

/**
 * 获取用户等级的文本展示形式
 * @param {*} level
 * @param {*} isText
 */
export function displayUserLevel(level = 1, isText: boolean = false) {
    if (isFullUserLevel(level)) {
        return getLangText('满级');
    }
    return isText
        ? getLangText('{$0}级').replace('{$0}', level + '')
        : 'LV.' + level;
}

// 返回两个颜色， primary 和 secondary ，为主要颜色和辅助颜色
// primary 是头像等级条的背景色、升级弹窗的等级文字颜色
// secondary 是头像等级条的文字颜色、升级弹窗的背景颜色
// isLabel 表示用在头像下方的 label，只当满级时颜色与其它是相反的，特殊处理一次
export function getUserLevelColorScheme(
    level: number,
    isLabel: boolean = false,
) {
    level = level || 1;
    const ret = {
        primary: '#3FAA34', // 绿色
        secondary: '#FFF',
        range: '1',
    };

    if (isFullUserLevel(level)) {
        if (isLabel) {
            ret.primary = '#292929'; // 黑色
            ret.secondary = '#FFBD2B'; // 金色
        } else {
            ret.primary = '#FFBD2B'; // 金色
            ret.secondary = '#292929'; // 黑色
        }
        ret.range = 'full';
    } else if (level >= 21) {
        ret.primary = '#FFBD2B'; // 金色
        ret.range = '21';
    } else if (level >= 11) {
        ret.primary = '#3F51B5'; // 蓝色
        ret.range = '11';
    }

    return ret;
}

export function getMedalIcon(
    type: string,
    rank: string,
    size = MEDAL_SIZE.LARGE,
    cdnHost: string = '',
) {
    function getBaseUrl() {
        let url = '';
        if (cdnHost) {
            url = cdnHost;
        } else {
            url = getStatic();
        }
        url += '/cdn/image';

        // 本地开发时，可以把整个 cdn-folder/ 下的 achievement 内容放到 ./images/ 下
        // 这个目录放在了 gitignore 中，如果需要部署查看，手动处理一下
        // 如果要查看多语效果，手动修改下面的 cn-cn 目录
        // url = '/themes/cn-cn/images/common/services/userAchievementService';
        // 提测时也可以放到以下目录
        // url = 'http://m.rentao.umucdn.cn/themes/common-cdn';  // TODO: 传cdn

        // 目录
        let dir = '/achievement';
        if (contextService.lang !== LANG_ENUM['zh-cn']) {
            dir = dir + '/global';
        }

        return url + dir;
    }

    // 默认返回大尺寸
    size = size || MEDAL_SIZE.LARGE;

    if (!type || !rank) {
        return;
    }

    let ret = '';
    ret = '/medal_' + size + '/' + type + '_' + rank;
    ret = getBaseUrl() + ret + '.png';

    // 勋章图的版本号。如果有更新，需要修改版本号清缓存
    const MEDAL_ICON_VERSION = '3';

    // 添加版本信息
    if (MEDAL_ICON_VERSION) {
        ret += '?' + MEDAL_ICON_VERSION;
    }
    return ret;
}
